import A from "dayjs";
import p from "./logger.mjs";
function m(o, t, e, ...r) {
  const s = p(process.env.APPLICATION_NAME || process.env.NEXT_PUBLIC_APPLICATION_NAME || process.env.REACT_APP_APPLICATION_NAME || "Application name not found in env"), n = `[${t}]: ${e}`;
  return s[o](n, ...r), `[${o?.toUpperCase()}] ${A().format("DD.MM.YYYY HH:mm:ss")} Uhr - ${n}`;
}
export {
  m as default
};
